import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const app = new modular({
    modules: modules
});

window.wishlist = function(el){

    fetch("/wp-json/snipcart/v1/user")
    .then(response => response.json())
    .then(data => {
        if(data.login == false){
            location.href = location.pathname + "/#/signin";
        } else {
            let action
            let formData = new FormData()
            if(el.classList.contains('add')){
                action = "add";
            } else {
                action = "remove";
            }
            formData.append('pid', el.dataset.pid)
            fetch("/wp-json/wishlist/"+action,{
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if(!data.error){
                    el.classList.remove("add");
                    el.classList.remove("remove");
                    el.classList.add(data.action)
                }
            });
        }
    });
}

window.switchLang = function(el) {
    let lang = el.value
    let url = el.dataset.url
    fetch("/wp-json/langswitcher/url?lang="+lang+"&url="+url)
    .then(response => response.json())
    .then(data => {
        location.href=data.url;
    });

}

window.switchFB = function(el) {
    if (el.value == 'oui') {
        el.closest('.snipcart-form__field').nextElementSibling.style.display = 'block';
        el.closest('.snipcart-form__field').nextElementSibling.querySelector('input').required = 'required';

    }
    else {
        el.closest('.snipcart-form__field').nextElementSibling.style.display = 'none';
        el.closest('.snipcart-form__field').nextElementSibling.querySelector('input').removeAttribute('required');
    }

}

window.onload = (event) => {
    const $style = document.getElementById('main-css');

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }
};

function init() {
    globals();

    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');
    }, 50);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('is-ready');
        html.classList.remove('is-loading');
    }, 300);
}

